import { 
    SET_AMOUNT_SLIDER,
    SET_PAYMENT_SLIDER,
    SET_TABLE,
    SET_TABLE_RECAP,
    SET_CURRENT_SIMULATION,
    SET_TOKEN,
    SET_MODAL,
    SET_LOADER,
    SET_SKIP_SIMULATION,
    SET_SKIP_RECAP,
    SET_USER_DATA, 
    SET_PASSED_DATA,
    SET_INTERNAL_THEME,
    SET_IS_SPEED_APP
} from '../constants/index';

import { INTERNAL_THEME } from "../../helpers/constants";

export const setAmountSlider = (amountOptions) => {
  return {
    type: SET_AMOUNT_SLIDER,
    payload: amountOptions,
  }
}

export const setAmountSliderThunk = (amountOptions) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setAmountSlider(amountOptions));
      resolve();
    });
  };
};

export const setPaymentSlider = (paymentOptions) => {
  return {
    type: SET_PAYMENT_SLIDER,
    payload: paymentOptions,
  }
}

export const setPaymentSliderThunk = (paymentOptions) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setPaymentSlider(paymentOptions));
      resolve();
    });
  };
};

export const setTable = (tableData) => {
  return {
    type: SET_TABLE,
    payload: tableData,
  }
}

export const setTableThunk = (tableData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setTable(tableData));
      resolve();
    });
  };
};

export const setTableRecap = (tableMainDataForCurrentAmount) => {
  return {
    type: SET_TABLE_RECAP,
    payload: tableMainDataForCurrentAmount,
  }
}

export const setTableRecapThunk = (tableMainDataForCurrentAmount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setTableRecap(tableMainDataForCurrentAmount));
      resolve();
    });
  };
};

export const setCurrentSimulation = (currentSimulationData) => {
  return {
    type: SET_CURRENT_SIMULATION,
    payload: currentSimulationData,
  }
}

export const setCurrentSimulationThunk = (currentSimulationData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setCurrentSimulation(currentSimulationData));
      resolve();
    });
  };
};

export const setToken = (token) => {
  return {
    type: SET_TOKEN,
    payload: token,
  }
}

export const setTokenThunk = (token) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setToken(token));
      resolve();
    });
  };
};

export const setModal = (modal, options) => {
  return {
    type: SET_MODAL,
    payload: {
      modal,
      options,
    },
  }
}

export const setModalThunk = (modal, options) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setModal(modal, options));
      resolve();
    });
  };
};

export const setSkipSimulation = (skipSimulation) => {
  return {
    type: SET_SKIP_SIMULATION,
    payload: skipSimulation,
  }
}

export const setSkipSimulationThunk = (skipSimulation) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setSkipSimulation(skipSimulation));
      resolve();
    });
  };
};

export const setSkipRecap = (skipRecap) => {
  return {
    type: SET_SKIP_RECAP,
    payload: skipRecap,
  }
}

export const setSkipRecapThunk = (skipRecap) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setSkipRecap(skipRecap));
      resolve();
    });
  };
};

export const setUserData = (userData) => {
  return {
    type: SET_USER_DATA,
    payload: userData,
  }
}

export const setUserDataThunk = (userData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setUserData(userData));
      resolve();
    });
  };
};

export const setPassed = (passed) => {
  return {
    type: SET_PASSED_DATA,
    payload: passed,
  }
}

export const setPassedThunk = (passed) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setPassed(passed));
      resolve();
    });
  };
};

export const setInternalTheme = (internalTheme = INTERNAL_THEME.COMPASS_BASE_SIMULATOR) => {
  return {
    type: SET_INTERNAL_THEME,
    payload: internalTheme,
  }
}

export const setInternalThemeThunk = (internalTheme = INTERNAL_THEME.COMPASS_BASE_SIMULATOR) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setInternalTheme(internalTheme));
      resolve();
    });
  };
}

export const setIsSpeedApp = (isSpeedApp = false) => {
  return {
    type: SET_IS_SPEED_APP,
    payload: isSpeedApp,
  }
}

export const setIsSpeedAppThunk = (isSpeedApp = false) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setIsSpeedApp(isSpeedApp));
      resolve();
    });
  };
}

export const setLoader = (visible) => {
  return {
    type: SET_LOADER,
    payload: {
      visible
    },
  }
}

export const setLoaderThunk = (visible) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoader(visible));
      resolve();
    });
  };
};
